import React, {useState, useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import navStyle from './style';
import {Link} from 'react-router-dom';

export default function MobileNav({navDetails, signOutPressed}) {
	const navItemSpacing = '1rem';
	let [extended, setExtended] = useState(false);
	let style = navStyle({isExtended: extended});
	let user = useContext(GlobalContext).user;

	function NavEle({name, href, i, onClick}) {
		return (
			<li
				style={{
					...style.li(),
					...{
						marginTop: navItemSpacing,
					},
				}}
			>
				<Link key={i} className='navLink' to={href} style={style.link()} onClick={onClick}>
					<p key={i} style={style.navText('right')}>
						{name}
					</p>
				</Link>
			</li>
		);
	}

	let rightNav = () => {
		if (!extended) {
			return (
				<ul style={style.side('right')}>
					<i className='fas fa-bars' style={style.hamburger()} onClick={hamburgerClicked}></i>
				</ul>
			);
		} else {
			return (
				<ul style={style.side('right', 'column', 'rtl', extended)}>
					<i className='fas fa-bars' style={style.hamburger()} onClick={hamburgerClicked}></i>
					{navDetails.left.map((entrie, i) => {
						return <NavEle {...entrie} i={i} />;
					})}
					{navDetails.right.map((entrie, i) => {
						return <NavEle {...entrie} i={i} />;
					})}
					{!user || !user.name ? (
						navDetails.auth.map((entrie, i) => {
							return <NavEle {...entrie} i={i} />;
						})
					) : (
						<>
							<NavEle name={`Hello ${user.name.first}`} href='#' />
							<NavEle name={`Sign out`} onClick={signOutPressed} href='#' />
						</>
					)}
				</ul>
			);
		}
	};

	return (
		<nav style={style.outerContainer()}>
			<ul style={style.side('left')}>
				<li
					style={{
						...style.li(),
						...{
							marginRight: '1rem',
						},
					}}
				>
					<Link className='navLink' to={navDetails.logo.href} style={style.link()}>
						<p className='me-2' style={style.titleText()}>
							{navDetails.logo.name}
						</p>
						<i className='fas fa-weight-hanging' style={style.logoIcon()}></i>
					</Link>
				</li>
			</ul>
			{rightNav()}
		</nav>
	);

	function hamburgerClicked() {
		let newExtended = !extended;
		setExtended(newExtended);
	}
}
